<div class="card">
	<div class="card-header">
		<h3>
			Edit Agent:
			{{agent.firstName}} {{agent.lastName}}
		</h3>
	</div>
	<div class="card-body">
		<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="container mt-4">
			<div class="row">
				<div class="col">
					<div class="mb-3">
						<label for="emailAddress" class="form-label">Email Address</label>
						<input type="emailAddress" id="emailAddress" class="form-control" formControlName="emailAddress"
							[class.is-invalid]="getFormControl('emailAddress').invalid && getFormControl('emailAddress').touched"
							placeholder="New email address" />
						<div *ngIf="getFormControl('emailAddress').errors && getFormControl('emailAddress').touched" class="invalid-feedback">
							<div *ngIf="controlInvalid('emailAddress')" class="text-danger">{{ getError('emailAddress') }}</div>
						</div>
					</div>

					<div class="mb-3">
						<label for="msisdn" class="form-label">Phone Number</label>
						<input type="text" id="msisdn" class="form-control" formControlName="msisdn"
							[class.is-invalid]="getFormControl('msisdn').invalid && getFormControl('msisdn').touched"
							placeholder="New phone number" />
						<div *ngIf="getFormControl('msisdn').errors && getFormControl('msisdn').touched"
							class="invalid-feedback">
							<div *ngIf="controlInvalid('msisdn')" class="text-danger">{{ getError('msisdn') }}</div>
						</div>
					</div>

					<div class="mb-3" *ngIf="!isSelf" >
						<label for="role" class="form-label">Role</label>
						<select id="role" class="form-select" formControlName="role"
							[class.is-invalid]="getFormControl('role').invalid && getFormControl('role').touched">
							<option value="" disabled>Select role</option>
							<option *ngFor="let r of data?.roles" [ngValue]="r.id">{{ r.name }}</option>
						</select>
						<div *ngIf="getFormControl('role').errors && getFormControl('role').touched"
							class="invalid-feedback">
							<span>Role is required.</span>
						</div>
					</div>
					<div class="mb-3">
						<label for="authenticator" class="form-label">Authenticator</label>
						<select id="authenticator" class="form-select" formControlName="authenticatorKey"
							[class.is-invalid]="getFormControl('authenticatorKey').invalid && getFormControl('authenticatorKey').touched">
							<option [value]="false" *ngIf="!agent.authenticatorKey">Disabled</option>
							<option [value]="false" *ngIf="agent.authenticatorKey">Enabled</option>
							<option [value]="true">New Token</option>
						</select>
					</div>
				</div>
				<div class="col text-center">
					<h3>Authenticator</h3>
					<ng-container *ngIf="getFormControl('authenticatorKey').value != 'true'" >
						<p *ngIf="!agent.authenticatorKey">Disabled</p>
						<p *ngIf="agent.authenticatorKey">Keep your current code unchanged </p>
					</ng-container>
					<ng-container *ngIf="getFormControl('authenticatorKey').value == 'true'" >
						<img [src]="data?.twoFactorAuthTokenQrCode"/>
						<div>Token:</div>
						<strong>{{data?.twoFactorAuthToken}}</strong>
					</ng-container>
				</div>
			</div>
			<button type="submit" class="btn btn-primary" [disabled]="formGroup.invalid" *ngIf="saving==false">Save</button>
			<button type="submit" class="btn btn-primary" [disabled]="true" *ngIf="saving==true">Saving</button>
		</form>
	</div>
</div>
